export const FEATURES = {
  sharedMarketingKits: 'shared_marketing_kits',
};

export default FEATURES;
